import * as Primitive from '@radix-ui/react-checkbox';
import type { ReactNode } from 'react';

import { cn } from '../lib/cn';
import { CheckIcon } from './icons';

interface ICheckboxProps {
  checked: boolean;
  onCheckedChange: (next: boolean) => void;
  label?: ReactNode;
  disabled?: boolean;
  className?: string;
  'aria-label'?: string;
}

export const Checkbox = ({
  checked,
  onCheckedChange,
  label,
  disabled,
  className,
  ...rest
}: ICheckboxProps) => (
  <label
    className={cn(
      'flex items-center gap-2 text-data',
      disabled ? 'text-faint' : checked ? 'text-primary' : 'text-muted',
      !disabled && 'cursor-pointer',
      className,
    )}
  >
    <Primitive.Root
      checked={checked}
      onCheckedChange={(next) => onCheckedChange(next === true)}
      disabled={disabled}
      className={cn(
        'flex size-check shrink-0 items-center justify-center rounded-check border',
        checked ? 'border-accent bg-accent text-surface' : 'border-suppressed',
        disabled && 'border-border-muted',
      )}
      {...rest}
    >
      <Primitive.Indicator className="flex">
        <CheckIcon size={10} />
      </Primitive.Indicator>
    </Primitive.Root>
    {label}
  </label>
);
